const PUBLIC_ROUTES = ['/auth/login', '/auth/activate'];
const PUBLIC_ROUTE_PREFIXES = [
	'/auth/forgotten-password/',
	'/auth/completeresetpassword/',
	'/auth/confirm-account/',
	'/auth/confirmaccount/',
	'/auth/createpassword/',
];

export const isPublicRoute = (pathname: string): boolean => {
	const path = pathname.toLowerCase();
	return (
		PUBLIC_ROUTES.includes(path) || PUBLIC_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix))
	);
};
